import {
	ItemContainer,
	SwitchWrapper,
	TextContent,
	Title,
	Description,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/styles.ts';
import { LabeledSegmentedControl } from '@dealstack/frontend/shared/components/LabeledSegmentedControl/LabeledSegmentedControl.tsx';

interface Props<T extends string> {
	title: string;
	description: string;
	value: T;
	options: { label: string; value: T }[];
	onChange: (value: T) => void;
	disabled?: boolean;
	showBorder?: boolean;
}

/** Requirement row whose answer is one of several options rather than on/off. */
export const SegmentedRequirementItem = <T extends string>({
	title,
	description,
	value,
	options,
	onChange,
	disabled = false,
	showBorder = true,
}: Props<T>) => {
	return (
		<ItemContainer $showBorder={showBorder}>
			<TextContent>
				<Title>{title}</Title>
				<Description>{description}</Description>
			</TextContent>

			<SwitchWrapper>
				<LabeledSegmentedControl
					value={value}
					data={options}
					onChange={onChange}
					disabled={disabled}
				/>
			</SwitchWrapper>
		</ItemContainer>
	);
};
